<script>
import MoveArrow from "@/components/move-arrow/MoveArrow.vue";
import TierInput from "@/components/tier-input/TierInput.vue";

export default {
  name: "TreeTable",
  components: {TierInput, MoveArrow},
  props: {
    columnList: {
      type: Array,
      default: () => ([])
    },
    maxLevel: {
      type: Number,
      default: 0,
    },
    data: {
      type: Array,
      default: () => ([])
    },
    height: {
      type: Number,
      default: 0
    },
    rowTemplate: {
      type: Object,
      default: () => ({})
    },

    expand: {
      type: Boolean,
      default: true,
    },
    showAdd: {
      type: Boolean,
      default: true,
    },

    // 禁用默认自动展开
    disabledExpandByDefault: {
      type: Boolean,
      default: false,
    },
    inputMaxLength:{
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
    }
  },
  methods: {
    // 添加行
    handleAddRow(row) {
      const current = row ? this.handleFindSelf(this.data, row.code) : null;
      const defaultParams = {
        code: new Date().getTime() + "",
        isFirstRow: !current,
        parentCode: current?.code || null,
        level: current ? (current?.level || 1) + 1 : 1,
        isNewAdd: true,
        sub: [],
      }
      const rowItem = Object.assign({}, this.rowTemplate, defaultParams);
      if(current) {
        if(!current.sub) current.sub = [];
        current.sub.unshift(rowItem);
      } else {
        this.data.unshift(rowItem);
      }
      this.$refs.table.loadData(this.data);
      this.$emit("addRow", rowItem);
    },

    // 根据code 寻找自己
    handleFindSelf(list, code) {
      for (const item of list) {
        if (item.code === code) return item;
        if(item.sub && item.sub.length) {
          const target = this.handleFindSelf(item.sub, code);
          if(target) return target;
        }
      }
    },

    // 展开/关闭
    handleChangeExpandState() {
      const flag = !this.expand;
      this.$emit("update:expand", flag);
      this.$refs.table.setAllTreeExpand(flag);
    },

    // 首次默认展开
    handleExpandByDefault(list) {
      list.forEach(item => {
        if (item.expand === "yes") {
          this.$refs.table.setTreeExpand(item, true);
        }

        if(item.sub && item.sub.length) {
          this.handleExpandByDefault(item.sub);
        }
      })
    },

    // 获取已选
    handleGetSelected() {
      return this.$refs.table.getCheckboxRecords();
    },

    // 获取tableRef
    getTableRef() {
      return this.$refs.table;
    },
  },
  watch: {
    data(list) {
      //  开启后不能默认展开，建议手动调用默认展开方法
      if(this.disabledExpandByDefault) return;
      if(list.length) {
        this.$nextTick(() => {
          this.handleExpandByDefault(this.data);
        })
      }
    },
  }
}
</script>

<template>
  <div>
    <el-link :underline="false" type="primary" class="mb16" @click="handleAddRow()" v-if="showAdd">+ {{$t('添加主分类')}}</el-link>
    <vxe-table
        v-bind="$attrs"
        v-on="$listeners"
        :height="height - 32"
        ref="table"
        border
        :row-config="{height: 120,useKey: true}"
        :column-config="{resizable: true}"
        show-overflow
        :scroll-y="{enabled: true, gt: 0}"
        :data="data"
        :checkbox-config="{highlight: true}"
        :tree-config="{rowField: 'code', childrenField: 'sub'}"
    >
      <vxe-column type="checkbox" width="60" fixed="left"></vxe-column>

      <vxe-column v-for="(item, index) in columnList"
                  :tree-node="index === 0"
                  :title="$t(item.label)"
                  :width="item.width || null"
                  :min-width="item.minWidth || null"
                  :fixed="item.fixed || null"
                  :key="index">
        <template v-slot="{row}">
          <slot :name="item.prop" :row="row">
            <div>
              <tier-input
                  v-if="item.type === 'input'"
                  :level="row.level"
                  :show-add-btn-by-level="maxLevel"
                  :is-parent="row.isFirstRow"
                  :children="row.sub"
                  @addChild="handleAddRow(row)"
                  v-model="row[item.prop]"
                  :input-max-length="inputMaxLength"
              />

              <move-arrow
                  :is-first="row.isFirstRow"
                  :row="row"
                  :list="data"
                  v-else-if="item.type === 'more'"/>

              <div v-else-if="item.type === 'switch'">
                <el-switch inactive-value="no" active-value="yes" v-model="row.expand" v-if="row.isFirstRow" />
              </div>
              <span v-else>{{ row[item.prop] }}</span>
            </div>
          </slot>
        </template>
      </vxe-column>
    </vxe-table>
  </div>
</template>

<style scoped>

</style>
